module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-8-5fce849f40925558e8763caec9d75abe.png";